module.exports = require('./dist/calculate-mip');
